export const ALGOLIA_APP_ID = "YP2T45KYEB";
export const ALGOLIA_ADMIN_KEY = "a797007f6825b2963c214393babaf107";